import { styled, useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';

export const MachineBadge = styled(Box)(({ bgcolor }) => ({
    backgroundColor: bgcolor,
    color: '#fff',
    borderRadius: 12,
    padding: 15,
    height: 100,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative',
    flexShrink: 0
}));

export const StatCard = styled(Box)(({ bordercolor, bgcolor }) => ({
    border: `2px solid ${bordercolor}`,
    borderRadius: 12,
    overflow: 'hidden',
    backgroundColor: bgcolor
}));
export const StatCardHeader = styled(Box)(({ bgcolor }) => ({
    backgroundColor: bgcolor,
    color: '#fff',
    display: 'flex',
    alignItems: 'center',
    gap: 6,
    padding: '12px 16px'
}));

export const StatCardBody = styled(Box)(({ bgcolor }) => ({
    backgroundColor: bgcolor,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '12px 12px 12px'
}));

export const FilterBar = styled(Box)(({ theme }) => ({
    backgroundColor: theme.palette.primary.main,
    borderRadius: 2,
    padding: '8px 12px'
}));

export const FilterBarSimple = styled(Box)(({ theme }) => ({
    borderRadius: 0,
    padding: '12px 16px'
}));
